(() => {
  const isoWithZone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;

  function initializeCountdown(bar) {
    if (bar.dataset.gniCountdownReady) return;
    bar.dataset.gniCountdownReady = 'true';
    const value = bar.dataset.gniPromoEnd || '';
    const end = isoWithZone.test(value) ? Date.parse(value) : NaN;
    const clock = bar.querySelector('[data-gni-countdown]');
    if (!clock || !Number.isFinite(end)) {
      bar.remove();
      return;
    }

    function update() {
      const remaining = Math.floor((end - Date.now()) / 1000);
      if (remaining <= 0) {
        window.clearInterval(timer);
        bar.remove();
        return;
      }
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      const time = [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
      clock.textContent = days > 0 ? `${days}d ${time}` : time;
      bar.hidden = false;
    }

    const timer = window.setInterval(update, 1000);
    update();
  }

  function initialize(root) {
    root.querySelectorAll('[data-gni-promo-end]').forEach(initializeCountdown);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
